import { bindable, inject } from "aurelia";
import { GrantService } from "../../services/grant-service";
import { ApplicationFormFieldService } from "../../services/application-form-field-service";
import { RequisitionService } from "../../services/requisition-service";
import { DecisionService } from "../../services/decision-service";
import { b64decode, isGuid } from "../../b64";

@inject(GrantService, ApplicationFormFieldService, RequisitionService, DecisionService)
export class GrantSummaryCustomElement {
  @bindable applicationId;

  grants = [];
  requisitions = [];
  decision = null;

  constructor(grantService, applicationFormFieldService, requisitionService, decisionService) {
    this.grantService = grantService;
    this.applicationFormFieldService = applicationFormFieldService;
    this.requisitionService = requisitionService;
    this.decisionService = decisionService;
  }

  bound() {
    this.applicationIdChanged(this.applicationId);
  }

  async applicationIdChanged(newId) {
    if (!newId) return;

    const decodedId = isGuid(newId) ? newId : b64decode(newId);

    try {
      this.grants = await this.grantService.get(decodedId);
      this.requisitions = await this.requisitionService.getByApplicationId(decodedId);
      this.decision = await this.decisionService.get(decodedId);


    } catch (error) {
      console.error("Fel vid hämtning av data:", error);
      this.grants = [];
      this.requisitions = [];
      this.decision = null;
    }
  }

  get hasGrants() {
    return this.grants && this.grants.length > 0;
  }

  get hasRequisitions() {
    return this.requisitions && this.requisitions.length > 0;
  }

  get grantsByYear() {
    if (!this.hasGrants) return [];

    // Gruppera grants per år och summera amount
    const yearMap = this.grants.reduce((acc, grant) => {
      const year = grant.year;
      if (!acc[year]) {
        acc[year] = {
          year: year,
          amount: 0
        };
      }
      acc[year].amount += Number(grant.amount || 0);
      return acc;
    }, {});

    return Object.values(yearMap).sort((a, b) => a.year - b.year);
  }

  get totalAmount() {
    return this.hasGrants
      ? this.grants.reduce((sum, g) => sum + Number(g.amount || 0), 0)
      : 0;
  }

  get totalRequisitionAmount() {
    return this.hasRequisitions
      ? this.requisitions
          .filter((req) => req.status === "Beviljad" || req.status === "Inskickad")
          .reduce((sum, r) => sum + Number(r.amount || 0), 0)
      : 0;
  }
}
